export default __webpack_public_path__ + "static/media/DXUnigothicStd-40.50d109ee.woff";